import React from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { PhotoProvider, PhotoView } from 'react-photo-view';

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "./slider.css";

// import required modules
import { Navigation } from "swiper";

const Slider = ({gallery}) => {
    return (
        <>
      <Swiper navigation={true} modules={[Navigation]} className="mySwiper">
        {
          gallery.map((img,i)=> <SwiperSlide key={i}>
            <PhotoProvider>
        <PhotoView src={img}>
          <img
            className="mx-auto"
            src={img}
            alt=""
          />
          </PhotoView>
          </PhotoProvider>

         </SwiperSlide>)
        }
       
      
      </Swiper>
    </>
    );
};

export default Slider;




